module.exports = __webpack_public_path__ + "assets/e3ead5c322c4e66bc7a41ead3572820e.png";